import React, {useCallback, useContext, useEffect, useRef, useState} from "react";

import EditView from "../../component/EditView";
import Texto from "../../component/form/texto/Texto";

import {MensagemContext} from "../../context/MensagemContext";
import {MensagemContextType} from "../../context/MensagemContextType";
import {TooltipPosition} from "../../component/form/TooltipPosition";
import Restaurante from "../../model/Restaurante";
import CpfCnpj from "../../component/form/cpfcnpj/CpfCnpj";
import RestauranteValidator from "./RestauranteValidator";
import CpfCnpjUtils from "../../utils/CpfCnpjUtils";
import Telefone from "../../component/form/telefone/Telefone";
import {Divider} from "primereact/divider";
import {Card} from "primereact/card";
import Combo from "../../component/form/combo/Combo";
import RestauranteTipoRestaurante from "../../model/RestauranteTipoRestaurante";
import TipoRestaurante from "../../model/TipoRestaurante";
import {Ajax} from "../../utils/Ajax";
import Switch from "../../component/form/switch/Switch";
import {PrimeIcons} from "primereact/api";
import styles from "./Restaurante.module.css";
import ItemEditView from "../../component/ItemEditView";
import {ItemEditViewColuna} from "../../component/ItemEditViewColuna";
import RestauranteDiferencial from "../../model/RestauranteDiferencial";
import Diferencial from "../../model/Diferencial";
import RestauranteHorarioFuncionamento from "../../model/RestauranteHorarioFuncionamento";
import {DiaSemana} from "../../model/DiaSemana";
import {Button} from "primereact/button";
import {InputMask} from "primereact/inputmask";
import {Accordion, AccordionTab} from 'primereact/accordion';
import RestauranteHorarioFuncionamentoPeriodo from "../../model/RestauranteHorarioFuncionamentoPeriodo";
import Calendario from "../../component/form/calendario/Calendario";
import RestauranteDiaDiferencial from "../../model/RestauranteDiaDiferencial";
import TextoMascara from "../../component/form/mascara/TextoMascara";
import moment, {Moment} from "moment";
import rest from "../../utils/EnvConfig";
import {Usuario} from "../../model/Usuario";
import ItemEditState from "../../component/ItemEditState";
import {RestauranteHorarioValidator} from "./RestauranteHorarioValidator";
import GoogleMapsAutoComplete from "../../component/form/googlemaps/GoogleMapsAutoComplete";
import Botao from "../../component/form/botao/Botao";
import {ObjectUtils} from "primereact/utils";
import {ConfirmDialog} from "primereact/confirmdialog";
import TelefoneBR from "../../component/form/telefoneBR/TelefoneBR";
import TelefoneUtils from "../../utils/TelefoneUtils";
import FormUtils from "../../utils/FormUtils";
import {RestauranteStatus} from "../../model/RestauranteStatus";
import {TipoPagamento} from "../../model/TipoPagamento";
import {Fieldset} from "primereact/fieldset";
import {Plano} from "../../model/Plano";
import {RadioButton} from "primereact/radiobutton";
import {CardPayment} from "@mercadopago/sdk-react";
import {ICardPaymentBrickPayer, ICardPaymentFormData} from "@mercadopago/sdk-react/esm/bricks/cardPayment/type";
import {PagamentoResponse} from "../../model/PagamentoResponse";
import {Dialog} from "primereact/dialog";
import {PagamentoDTO} from "../../dto/PagamentoDTO";
import {PagamentoPixResponse} from "../../model/PagamentoPixResponse";
import {useNavigate} from "react-router-dom";
import {PlanoTipo} from "../../model/PlanoTipo";
import DinheiroUtils from "../../utils/DinheiroUtils";
import {PlanoPeriodo} from "../../model/PlanoPeriodo";
import {DropdownProps} from "primereact/dropdown";
import {useKeycloak} from "../../keycloak/useKeycloak";
import {TipoUsuarioKeycloak} from "../../keycloak/TipoUsuarioKeycloak";
import {RoleBasedAccess} from "../../keycloak/RoleBasedAccess";
import {UsuarioKeycloak} from "../../model/UsuarioKeycloak";
import TextoGrupo from "../../component/form/texto-grupo/TextoGrupo";
import {InputSwitch} from "primereact/inputswitch";

function RestauranteEdit() {
    const isHomologacao: boolean = true;
    const {hasRole, user, token} = useKeycloak();
    const restauranteStatus: RestauranteStatus[] = [RestauranteStatus.ATIVO, RestauranteStatus.INATIVO, RestauranteStatus.INATIVO_ADMIN, RestauranteStatus.PENDENTE];

    const [itemEditState] = useState<ItemEditState>(new ItemEditState());

    const navigate = useNavigate();
    const {error, info} = useContext(MensagemContext) as MensagemContextType;
    const [entidade, setEntidade] = useState<Restaurante>(new Restaurante());
    const [usuarios, setUsuarios] = useState<Usuario[]>([]);
    const [tiposRestaurantes, setTiposRestaurantes] = useState<TipoRestaurante[]>([]);
    const [diferenciais, setDiferenciais] = useState<Diferencial[]>([]);
    const [planos, setPlanos] = useState<Plano[]>([]);

    const [restauranteTipo, setRestauranteTipo] = useState<RestauranteTipoRestaurante>(new RestauranteTipoRestaurante());
    const [statusRestauranteTipo, setStatusRestauranteTipo] = useState(restauranteTipo.status ? restauranteTipo.status : true);

    const [restauranteDiferencial, setRestauranteDiferencial] = useState<RestauranteDiferencial>(new RestauranteDiferencial());
    const [statusRestauranteDiferencial, setStatusRestauranteDiferencial] = useState(restauranteDiferencial.status ? restauranteDiferencial.status : true);

    const [restauranteDiaDiferencial, setRestauranteDiaDiferencial] = useState<RestauranteDiaDiferencial>(new RestauranteDiaDiferencial());
    const [statusRestauranteDiaDiferencial, setStatusRestauranteDiaDiferencial] = useState(restauranteDiaDiferencial.fechado ? restauranteDiferencial.status : true);

    const [copiarHorariosConfirm, setCopiarHorariosConfirm] = useState<boolean>(false);
    const [adicionarHorarioConfirm, setAdicionarHorarioConfirm] = useState<boolean>(false);

    const bottomCopiaHorariosRef = useRef<any>();
    const horariosEspeciaisScrollRef = useRef<any>();

    const [pagamentoDTO, setPagamentoDTO] = useState<PagamentoDTO>(new PagamentoDTO());
    const [pagamentoVisible, setPagamentoVisible] = useState(false);
    const [loadingPix, setLoadingPix] = useState(false);
    const [endLoadingSalvarFunction, setEndLoadingSalvarFunction] = useState<() => void>();

    // ----
    useEffect(() => {
        Ajax.of()
            .error(error)
            .setTokenKeycloak(token!)
            .obterTodos(`${rest.tipoRestaurante}`,
                (data) => setTiposRestaurantes(data));

        Ajax.of()
            .error(error)
            .setTokenKeycloak(token!)
            .obterTodos(`${rest.diferencial}`,
                (data) => setDiferenciais(data));

        Ajax.of()
            .error(error)
            .setTokenKeycloak(token!)
            .obterTodos(`${rest.plano}`,
                (data) => setPlanos(data));

        if (hasRole(TipoUsuarioKeycloak.ADMIN)) {
            Ajax.of()
                .error(error)
                .setTokenKeycloak(token!)
                .obterTodosCustom(`${rest.usuario}/${rest.usuariosRestaurante}`,
                    (data) => {
                    setUsuarios(data);
                });
        }

        if (hasRole(TipoUsuarioKeycloak.CLIENTE)) {
            entidade.usuarioUuid = user.id;
        }

        montarGridHorarioFuncionamentoNovo();
    }, []);

    // TODO deveria ficar na classe Restaurante, mas por problemas de atualização do useState, por enquanto vai ficar assim
    useEffect(() => {
        if (entidade.horariosFuncionamento && entidade.horariosFuncionamento.length > 0) {
            const diasOrdem: string[] = [
                    'segunda-feira',
                    'terça-feira',
                    'quarta-feira',
                    'quinta-feira',
                    'sexta-feira',
                    'sábado',
                    'domingo'
            ];

            setEntidade({...entidade, horariosFuncionamento: entidade.horariosFuncionamento!.sort((a, b) => {
                    const indiceA = diasOrdem!.indexOf(a.diaSemana!.toLowerCase());
                    const indiceB = diasOrdem!.indexOf(b.diaSemana!.toLowerCase());
                    return indiceA - indiceB;
                })
            });
        }
    }, [entidade.horariosFuncionamento]);

    // tipos restaurante
    const validarRestauranteTipos = (onSuccess: () => void) => {
        if (!restauranteTipo.tipoRestaurante) {
            error("Tipo do restaurante é obrigatório");
            return;
        }

        if (entidade.tiposRestaurantes) {
            for (const tipo of entidade.tiposRestaurantes) {
                if (tipo.tipoRestaurante?.id === restauranteTipo.tipoRestaurante.id) {
                    error("Este tipo de restaurante já foi informado");
                    return;
                }
            }
        }

        onSuccess();
    }

    const adicionarRestauranteTipos = () => {
        validarRestauranteTipos(() => {
            if (entidade.tiposRestaurantes !== undefined) {
                setEntidade({...entidade, tiposRestaurantes: [...entidade.tiposRestaurantes, restauranteTipo]});
                setRestauranteTipo(new RestauranteTipoRestaurante());
            }
            itemEditState.limparState();
        });
    }



    const editarRestauranteTipos = (item: RestauranteTipoRestaurante) => {
        if (itemEditState.state) {
            error(`Já existe um item sendo editado em ${itemEditState.nomeSessaoItem}`);
            return;
        }

        itemEditState.buildItemState("Tipo do restaurante", item);

        setRestauranteTipo(item);
        if (entidade.tiposRestaurantes !== undefined) {
            setEntidade({...entidade, tiposRestaurantes: [...entidade.tiposRestaurantes.filter(t => t !== item)]});
        }
    }

    const removerRestauranteTipos = (item: RestauranteTipoRestaurante) => {
        if (entidade.tiposRestaurantes !== undefined) {
            setEntidade({ ...entidade, tiposRestaurantes: [...entidade.tiposRestaurantes.filter(t => t !== item)] });
        }
    }

    const restauranteTipoOnChangeHandler = (e: any) => {
        setRestauranteTipo({ ...restauranteTipo, [e.target.id]: e.target.value });
    }

    const switchOnChangeHandler = (e: any) => {
        setStatusRestauranteTipo(e.value);
        setRestauranteTipo({ ...restauranteTipo, status: e.value });
    }

    const statusRestauranteTipoTemplate = (tipo: RestauranteTipoRestaurante) => {
        return tipo.status ? "Sim" : "Não";
    };
    // -------


    // diferencial
    const validarRestauranteDiferencias = (onSuccess: () => void) => {
        if (!restauranteDiferencial.diferencial) {
            error("Diferencial é obrigatório");
            return;
        }

        if (entidade.diferenciais) {
            for (const diferencial of entidade.diferenciais) {
                if (diferencial.diferencial?.id === restauranteDiferencial.diferencial.id) {
                    error("Este diferencial já foi informado");
                    return;
                }
            }
        }

        onSuccess();
    }

    const adicionarRestauranteDiferenciais = () => {
        validarRestauranteDiferencias(() => {
            if (entidade.diferenciais !== undefined) {
                setEntidade({...entidade, diferenciais: [...entidade.diferenciais, restauranteDiferencial]});
                setRestauranteDiferencial(new RestauranteDiferencial());

                itemEditState.limparState();
            }
        });
    }

    const editarRestauranteDiferenciais = (item: RestauranteDiferencial) => {
        if (itemEditState.state) {
            error(`Já existe um item sendo editado em ${itemEditState.nomeSessaoItem}`);
            return;
        }

        itemEditState.buildItemState("Diferenciais", item);

        setRestauranteDiferencial(item);
        if (entidade.diferenciais !== undefined) {
            setEntidade({ ...entidade, diferenciais: [...entidade.diferenciais.filter(t => t !== item)] });
        }
    }

    const removerRestauranteDiferenciais = (item: RestauranteDiferencial) => {
        if (entidade.diferenciais !== undefined) {
            setEntidade({ ...entidade, diferenciais: [...entidade.diferenciais.filter(t => t !== item)] });
        }
    }

    const restauranteDiferencialOnChangeHandler = (e: any) => {
        setRestauranteDiferencial({ ...restauranteDiferencial, [e.target.id]: e.target.value });
    }

    const switchDiferencialOnChangeHandler = (e: any) => {
        setStatusRestauranteDiferencial(e.value);
        setRestauranteDiferencial({ ...restauranteDiferencial, status: e.value });
    }

    const statusRestauranteDiferencialTemplate = (tipo: RestauranteDiferencial) => {
        return tipo.status ? "Sim" : "Não";
    };

    // ----



    // dia diferencial
    const validarRestauranteDiaDiferenciais = (onSuccess: () => void) => {
        if (!restauranteDiaDiferencial.data) {
            error("Data do dia diferencial é obrigatório");
            return;
        }

        if (!restauranteDiaDiferencial.fechado && !restauranteDiaDiferencial.horaInicio) {
            error("Hora início do dia diferencial é obrigatório");
            return;
        }

        if (!restauranteDiaDiferencial.fechado && !restauranteDiaDiferencial.horaFim) {
            error("Hora fim do dia diferencial é obrigatório");
            return;
        }

        // @ts-ignore
        for (const horarioDiferencial of entidade.horariosFuncionamentoDiferencial) {
            const mesmoDia = moment(horarioDiferencial.data).format("YYYY-MM-DD")
                === moment(restauranteDiaDiferencial.data).format("YYYY-MM-DD");

            if ((restauranteDiaDiferencial.fechado && mesmoDia) ||
                (!restauranteDiaDiferencial.fechado && mesmoDia && horarioDiferencial.fechado)) {
                const abertoOuFechado: string = horarioDiferencial.fechado ? "fechado" : "em aberto";
                error(`Nesta data existe horário(s) ${abertoOuFechado}. Corrija abaixo antes de continuar.`);
                return;
            }
        }

        if (!RestauranteHorarioValidator(entidade, error, restauranteDiaDiferencial)) {
            return;
        }

        onSuccess();
    }

    const adicionarRestauranteDiaDiferenciais = () => {
        validarRestauranteDiaDiferenciais(() => {
            if (entidade.horariosFuncionamentoDiferencial !== undefined) {
                setEntidade({ ...entidade, horariosFuncionamentoDiferencial: [...entidade.horariosFuncionamentoDiferencial, restauranteDiaDiferencial] });
                setRestauranteDiaDiferencial(new RestauranteDiaDiferencial());
                setStatusRestauranteDiaDiferencial(true);

                itemEditState.limparState();

                scrollCopiarHorarios();
            }
        });
    }

    const editarRestauranteDiaDiferenciais = (item: RestauranteDiaDiferencial) => {
        if (itemEditState.state) {
            error(`Já existe um item sendo editado em ${itemEditState.nomeSessaoItem}`);
            return;
        }

        itemEditState.buildItemState("Horário de funcionamento diferencial", item);

        setRestauranteDiaDiferencial(item);
        setStatusRestauranteDiaDiferencial(item.fechado);

        if (entidade.horariosFuncionamentoDiferencial !== undefined) {
            setEntidade({ ...entidade, horariosFuncionamentoDiferencial: [...entidade.horariosFuncionamentoDiferencial.filter(t => t !== item)] });
        }

        scrollEditarHorariosEspeciais();
    }

    const removerRestauranteDiaDiferenciais = (item: RestauranteDiaDiferencial) => {
        if (entidade.horariosFuncionamentoDiferencial !== undefined) {
            setEntidade({ ...entidade, horariosFuncionamentoDiferencial: [...entidade.horariosFuncionamentoDiferencial.filter(t => t !== item)] });
        }
    }

    const restauranteDiaDiferencialOnChangeHandler = (e: any) => {
        const dataSelecionada: Date = e.target.value;
        setRestauranteDiaDiferencial({ ...restauranteDiaDiferencial, [e.target.id]: dataSelecionada });
    }

    const copiarHorariosDoDiaSelecionado = () => {
        if (restauranteDiaDiferencial.data) {
            const dataSelecionada: Date = restauranteDiaDiferencial.data;
            const diaSemanSelecionado: string = dataSelecionada
                .toLocaleString('pt-BR', {weekday: 'long'})
                .toLowerCase();

            if (entidade.horariosFuncionamento) {
                let horariosCopiadosSucesso = true;
                for (const horarioFuncionamento of entidade.horariosFuncionamento) {
                    if (horarioFuncionamento.periodos && horarioFuncionamento.diaSemana?.toLowerCase() === diaSemanSelecionado) {
                        for (const periodo of horarioFuncionamento.periodos) {
                            let horarioDiferencial = new RestauranteDiaDiferencial();
                            horarioDiferencial.fechado = false;
                            horarioDiferencial.data = dataSelecionada;
                            horarioDiferencial.horaInicio = periodo.horaInicio;
                            horarioDiferencial.horaFim = periodo.horaFim;

                            if (entidade.horariosFuncionamentoDiferencial
                                && entidade.horariosFuncionamentoDiferencial
                                    .filter(h => ObjectUtils.deepEquals(h, horarioDiferencial)).length > 0) {
                                error("Já existe uma cópia desse horário.");
                                horariosCopiadosSucesso = false;
                                break;
                            }

                            if (!RestauranteHorarioValidator(entidade, error, horarioDiferencial)) {
                                horariosCopiadosSucesso = false;
                                return;
                            }

                            setEntidade(prevEntidade => ({
                                ...prevEntidade,
                                // @ts-ignore
                                horariosFuncionamentoDiferencial: [...prevEntidade.horariosFuncionamentoDiferencial, horarioDiferencial]
                            }));
                        }
                    }
                }

                if (horariosCopiadosSucesso) {
                    info("Horários copiados com sucesso.");
                    scrollCopiarHorarios();
                }
            }
            return;
        }

        error("Selecione uma data para ser copiada.");
    }

    const switchDiaDiferencialOnChangeHandler = (e: any) => {
        const statusFechado = e.value;
        setStatusRestauranteDiaDiferencial(statusFechado);

        if (statusFechado) {
            setRestauranteDiaDiferencial({ ...restauranteDiaDiferencial,
                fechado: statusFechado, horaInicio: undefined, horaFim: undefined });
            return;
        }

        setRestauranteDiaDiferencial({ ...restauranteDiaDiferencial, fechado: statusFechado });
    }

    const statusRestauranteDiaDiferencialTemplate = (tipo: RestauranteDiaDiferencial): string => {
        return tipo.fechado ? "Fechado" : "Aberto";
    };

    const dataRestauranteDiaDiferencialTemplate = (tipo: RestauranteDiaDiferencial): string => {
        if (tipo.data) {
            const novaData: Moment = moment(tipo.data, "YYYY-MM-DD");
            return novaData.format("DD/MM/YYYY");
        }
        return "";
    };

    const deliveryRestauranteDiaDiferencialTemplate = (tipo: RestauranteDiaDiferencial): string => {
        return tipo.delivery ? "Sim" : "Não";
    };

    // --------

    const usuarioOnChangeHandler = (e: any) => {
        setEntidade({ ...entidade, usuarioUuid: e.target.value });
    }

    const planoOnChangeHandler = (e: any) => {
        setEntidade({ ...entidade, plano: e.target.value });
    }

    const statusOnChangeHandler = (e: any) => {
        setEntidade({ ...entidade, status: e.target.value });
    }

    const montarGridHorarioFuncionamentoNovo = () => {
        if (!entidade.id) {
            montarGridHorarioFuncionamento(entidade);
        }
    }

    const montarGridHorarioFuncionamento = (data: Restaurante) => {
        if (data.horariosFuncionamento && data.horariosFuncionamento.length == 0) {
            const diasDaSemana: DiaSemana[] = Object.values(DiaSemana);
            const horarios: RestauranteHorarioFuncionamento[] = [];

            diasDaSemana.forEach((key, value) => {
                const novoHorarioFuncionamento = new RestauranteHorarioFuncionamento();
                novoHorarioFuncionamento.diaSemana = key;
                novoHorarioFuncionamento.periodos = [new RestauranteHorarioFuncionamentoPeriodo()];
                horarios.push(novoHorarioFuncionamento);
            });

            Promise.all(horarios).then(() => {
                setEntidade({...data,
                    horariosFuncionamento: horarios,
                    cpfCnpj: CpfCnpjUtils.formatarCampoString(data.cpfCnpj),
                    // @ts-ignore
                    horariosFuncionamentoDiferencial: [...data.horariosFuncionamentoDiferencial]});
            });
        } else {
            corrigirDataDiaDiferencial(data);
            setEntidade({...data,
                cpfCnpj: CpfCnpjUtils.formatarCampoString(data.cpfCnpj),
                // @ts-ignore
                horariosFuncionamentoDiferencial: [...data.horariosFuncionamentoDiferencial]});
        }
    }

    const corrigirDataDiaDiferencial = (data: Restaurante) => {
        if (data.horariosFuncionamentoDiferencial) {
            data.horariosFuncionamentoDiferencial.forEach(dia => {
                const novaData: Moment = moment(dia.data, "YYYY-MM-DD");
                dia.data = novaData.toDate();
            });
        }
    }

    const editEntidade = (data: Restaurante) => {
        montarGridHorarioFuncionamento(data);
    }

    const entidadeOnChangeHandler = (e: any) => {
        setEntidade({ ...entidade, [e.target.id]: e.target.value });
    }

    const enderecoCompletoOnChangeHandler = (e: any) => {
        setEntidade({ ...entidade, enderecoCompleto: e.value });
    }

    const redefinirLatitudeLongitute = (e: any) => {
        if (entidade.latitude && entidade.longitude) {
            if (/^[a-zA-Z0-9]$/.test(e.key)) {
                setEntidade({...entidade, latitude: undefined, longitude: undefined});
            }
        }
    }

    const definirLatitudeLongitudeEndereco = (endereco: string, latitude: number, longitude: number): void => {
        setEntidade({...entidade, enderecoCompleto: endereco, latitude: latitude, longitude: longitude});
    };

    const periodoFuncionamentoChangeHandler = (e: any, horarioFuncionamentoIndex: number, periodoIndex: number) => {
        // @ts-ignore
        entidade.horariosFuncionamento[horarioFuncionamentoIndex].periodos[periodoIndex] = {
            // @ts-ignore
            ...entidade.horariosFuncionamento[horarioFuncionamentoIndex].periodos[periodoIndex],
            [e.target.id]: e.target.value
        };

        if (entidade.horariosFuncionamento) {
            setEntidade({...entidade, horariosFuncionamento: [...entidade.horariosFuncionamento]});
        }
    }

    // const periodoFuncionamentoDeliveryChangeHandler = (e: any, horarioFuncionamentoIndex: number, periodoIndex: number) => {
    //     // @ts-ignore
    //     entidade.horariosFuncionamento[horarioFuncionamentoIndex].periodos[periodoIndex] = {
    //         // @ts-ignore
    //         ...entidade.horariosFuncionamento[horarioFuncionamentoIndex].periodos[periodoIndex],
    //         [e.target.id]: e.target.value
    //     };
    //
    //     if (entidade.horariosFuncionamento) {
    //         setEntidade({...entidade, horariosFuncionamento: [...entidade.horariosFuncionamento]});
    //     }
    // }

    const adicionarPeriodoFuncionamentoHandler = (horarioFuncionamento: RestauranteHorarioFuncionamento,
                                                  horarioFuncionamentoIndex: number) => {
        if (horarioFuncionamento && horarioFuncionamento.periodos) {
            for (const periodo of horarioFuncionamento.periodos) {
                if (!periodo.horaInicio || periodo.horaInicio === "") {
                    error("Informe um hora de início e fim na tabela de dias/horários de funcionamento");
                    return;
                }

                if (!periodo.horaFim || periodo.horaFim === "") {
                    error("Informe um hora de início e fim na tabela de dias/horários de funcionamento");
                    return;
                }
            }
        }

        // @ts-ignore
        entidade.horariosFuncionamento[horarioFuncionamentoIndex].periodos = [
            // @ts-ignore
            ...entidade.horariosFuncionamento[horarioFuncionamentoIndex].periodos, new RestauranteHorarioFuncionamentoPeriodo()
        ];

        if (entidade.horariosFuncionamento) {
            setEntidade({...entidade, horariosFuncionamento: [...entidade.horariosFuncionamento]});
        }
    }

    const removerPeriodoFuncionamentoHandler = (horarioFuncionamento: RestauranteHorarioFuncionamento,
                                                horarioFuncionamentoIndex: number, periodoIndex: number) => {
        // @ts-ignore
        if (entidade.horariosFuncionamento[horarioFuncionamentoIndex].periodos.length > 1) {
            // @ts-ignore
            entidade.horariosFuncionamento[horarioFuncionamentoIndex].periodos.splice(periodoIndex, 1);

            if (entidade.horariosFuncionamento) {
                setEntidade({...entidade, horariosFuncionamento: [...entidade.horariosFuncionamento]});
            }
        } else {
            // @ts-ignore
            entidade.horariosFuncionamento[horarioFuncionamentoIndex].periodos[0].horaInicio = null;
            // @ts-ignore
            entidade.horariosFuncionamento[horarioFuncionamentoIndex].periodos[0].horaFim = null;
            // @ts-ignore
            setEntidade({...entidade, horariosFuncionamento: [...entidade.horariosFuncionamento]});
        }
    }

    const validarHorarioFuncionamentoOnBlurHandler = (horaInicio?: string, horaFim?: string) => {
        if (horaInicio && horaFim) {
            RestauranteHorarioValidator(entidade, error);
        }
    }

    const validar = async (): Promise<boolean> => {
        if (itemEditState.state) {
            error(`Existe um item sendo editado em ${itemEditState.nomeSessaoItem}`);
            return false;
        }

        return await RestauranteValidator(entidade, error);
    };

    const whatsAppOnChangeHandler = (telefoneFormatado: string) => {
        setEntidade({ ...entidade, whatsapp: telefoneFormatado });
    }

    const whatsAppValidateOnBlurHandler = (e: any) => {
        if (e.target.value && !TelefoneUtils.isTelefone(e.target.value)) {
            FormUtils.invalidarComponente(error,
                "Formato do WhatsApp inválido. Deve ser por exemplo (44) 99999-9999");
        }
    }

    const scrollCopiarHorarios = () => {
        if (bottomCopiaHorariosRef.current) {
            bottomCopiaHorariosRef.current.scrollIntoView({ behavior: "smooth" });
        }
    }

    const scrollEditarHorariosEspeciais = () => {
        if (horariosEspeciaisScrollRef.current) {
            horariosEspeciaisScrollRef.current.scrollIntoView({ behavior: "smooth" });
        }
    }

    const planosItemTemplate = (option: Plano) => {
        if (option) {
            if (option.tipo === PlanoTipo.GRATIS) {
                return `${option.descricao}`;
            }

            if (option.tipo === PlanoTipo.PAGO && option.periodo === PlanoPeriodo.MENSAL) {
                return `${option.descricao} - ${DinheiroUtils.formatToDinheiro(option.valor)} por mês`;
            }

            if (option.tipo === PlanoTipo.PAGO && option.periodo === PlanoPeriodo.SEMESTRAL) {
                return `${option.descricao} - ${DinheiroUtils.formatToDinheiro(option.valor)} por semestre`;
            }

            if (option.tipo === PlanoTipo.PAGO && option.periodo === PlanoPeriodo.ANUAL) {
                return `${option.descricao} - ${DinheiroUtils.formatToDinheiro(option.valor)} por ano`;
            }
        }

        return "";
    }

    const planosValueTemplate = (option: Plano, props: DropdownProps) => {
        if (option) {
            return planosItemTemplate(option);
        }
        return props.placeholder;
    }

    const usuariosItemTemplate = (option: UsuarioKeycloak) => {
        if (option) {
            return `${option.nome} - ${option.email}`;
        }

        return "";
    }

    const usuariosValueTemplate = (option: UsuarioKeycloak, props: DropdownProps) => {
        if (option) {
            return usuariosItemTemplate(option);
        }
        return props.placeholder;
    }


    const efetuarPagamentoPix = async () => {
        setLoadingPix(true);

        const parametrosPix = {
            transaction_amount: isHomologacao ? 0.01 : entidade.plano?.valor,
            description: `Pagamento do plano ${entidade.plano?.descricao}`,
            payment_method_id: "PIX",
            payer: {
                email: user.email,
                identification: {
                    type: "CPF",
                    number: ""
                }
            }
        }

        await Ajax.of()
            .setTokenKeycloak(token!)
            .postRegistroCustom(`${rest.server}${rest.mercadoPago}/${rest.mercadoPagoPagamentoPix}`, parametrosPix, async (response: PagamentoPixResponse) => {
            info(response.mensagem, true);

            pagamentoDTO.status = response.status;
            pagamentoDTO.idTransacaoMercadoPago = response.idTransacaoMercadoPago;

            await salvarRestaurante(pagamentoDTO);

            setLoadingPix(false);

            window.open(response.urlPagamentoMercadoPago, "_blank");
            navigate("/restaurante");
        }, (err: Error) => {
            setLoadingPix(false);
            const response: PagamentoResponse = JSON.parse(err.message);
            error(response.mensagem);
            if (endLoadingSalvarFunction) endLoadingSalvarFunction();
        });
    }

    const iniciarPagamento = useCallback(async (endLoadingFunc: () => void) => {
        setEndLoadingSalvarFunction(() => endLoadingFunc);

        if (JSON.parse(rest.periodoBeta!) === true) {
            await salvarRestaurante();
            navigate("/restaurante");
            return;
        }

        if (entidade.plano?.tipo === PlanoTipo.GRATIS) {
            await salvarRestaurante();
            navigate("/restaurante");
            return;
        }

        await efetuarPagamentoMercadoPago(
            async () => {},
            async () => {
                error("Algo deu errado na inicialização do pagamento.");
                endLoadingFunc();
            }
        );
    }, [error, entidade]);

    const efetuarPagamentoMercadoPago = async (onSuccess: () => Promise<void>,
                                               onError: () => Promise<void>) => {
        if (entidade.uuid) {
            await salvarRestaurante();
            navigate("/restaurante");
            return;
        }

        if (entidade.plano?.tipo === PlanoTipo.PAGO) {
            setPagamentoVisible(true);
            await onSuccess();
        }
    }

    const salvarRestaurante = async (pagamentoDTO?: PagamentoDTO) => {
        await Ajax.of()
            .setTokenKeycloak(token!)
            .salvarRegistro(`${rest.restaurante}`,
                entidade, async (response: any) => {
                    if (pagamentoDTO) {
                        pagamentoDTO.restaurante = response as Restaurante;

                        Ajax.of()
                            .setTokenKeycloak(token!)
                            .salvarRegistro(`${rest.cobrancaPagamento}`,
                            pagamentoDTO, async (resp: any) => {
                                info("Pagamento registrado com sucesso");
                            }
                        ).then();
                    }
                }
            );
    }

    const onHidePagamento = useCallback(() => {
        if (endLoadingSalvarFunction) {
            endLoadingSalvarFunction();
        }
        if (!pagamentoVisible) return;
        setPagamentoVisible(false);
    }, [endLoadingSalvarFunction, pagamentoVisible]);

    return (
        <>
            <Dialog header="Pagamento" visible={pagamentoVisible} style={{width: '50vw'}}
                    onHide={onHidePagamento}
                    position={"top"}>
                <Fieldset legend={"Forma de pagamento"}>
                    <div className="card flex">
                        <div className="flex align-items-center" style={{paddingRight: "15px"}}>
                            <RadioButton inputId="pagamentoTipoPix" name="pagamentoTipo"
                                         value={TipoPagamento.PIX}
                                         onChange={(e) => setPagamentoDTO({...pagamentoDTO, formaPagamento: e.value})}
                                         checked={pagamentoDTO.formaPagamento === TipoPagamento.PIX}/>
                            <label htmlFor="pagamentoTipoPix" className="ml-2">PIX</label>
                        </div>

                        <div className="flex align-items-center" style={{paddingRight: "15px"}}>
                            <RadioButton inputId="pagamentoTipoCartaoCredito" name="pagamentoTipo"
                                         value={TipoPagamento.CARTAO_CREDITO}
                                         onChange={(e) => setPagamentoDTO({...pagamentoDTO, formaPagamento: e.value})}
                                         checked={pagamentoDTO.formaPagamento === TipoPagamento.CARTAO_CREDITO}/>
                            <label htmlFor="pagamentoTipoCartaoCredito" className="ml-2">Cartão de Crédito</label>
                        </div>
                    </div>
                </Fieldset>

                {pagamentoDTO.formaPagamento === TipoPagamento.CARTAO_CREDITO && (
                    <>
                        <p className="m-0">
                            <Accordion activeIndex={[-1]}>
                                <AccordionTab header="Master Card">
                                    <p className="m-0">
                                        Número: 5031 4332 1540 6351
                                    </p>
                                    <p className="m-0">
                                        CVC: 123
                                    </p>
                                    <p className="m-0">
                                        Vencimento: 11/25
                                    </p>
                                </AccordionTab>
                                <AccordionTab header="Visa">
                                    <p className="m-0">
                                        Número: 4235 6477 2802 5682
                                    </p>
                                    <p className="m-0">
                                        CVC: 123
                                    </p>
                                    <p className="m-0">
                                        Vencimento: 11/25
                                    </p>
                                </AccordionTab>
                                <AccordionTab header="American Express">
                                    <p className="m-0">
                                        Número: 3753 651535 56885
                                    </p>
                                    <p className="m-0">
                                        CVC: 1234
                                    </p>
                                    <p className="m-0">
                                        Vencimento: 11/25
                                    </p>
                                </AccordionTab>
                                <AccordionTab header="Status de pagamento">
                                    <p>
                                        Para testar diferentes resultados de pagamento, insira o status desejado no <b>nome
                                        do
                                        titular</b> do cartão:
                                    </p>
                                    <p className="m-0">
                                        Nome do titular: APRO <br/>
                                        Descrição: Simula um pagamento aprovado <br/>
                                        CPF: 12345678909
                                    </p>
                                    <br/>
                                    <p className="m-0">
                                        Nome do titular: OTHE <br/>
                                        Descrição: Simula um pagamento recusado. Qualquer nome informado também gera
                                        esse
                                        erro. <br/>
                                        CPF: 12345678909
                                    </p>
                                    <br/>
                                    <p className="m-0">
                                        Nome do titular: CONT <br/>
                                        Descrição: Simula um pagamento pendente <br/>
                                        CPF: 12345678909
                                    </p>
                                    <br/>
                                    <p className="m-0">
                                        Nome do titular: CALL <br/>
                                        Descrição: Simula um pagamento recusado com validação para autorizar <br/>
                                        CPF: 12345678909
                                    </p>
                                    <br/>
                                    <p className="m-0">
                                        Nome do titular: FUND <br/>
                                        Descrição: Simula um pagamento recusado por quantia insuficiente. <br/>
                                        CPF: 12345678909
                                    </p>
                                    <br/>
                                    <p className="m-0">
                                        Nome do titular: SECU <br/>
                                        Descrição: Simula um pagamento recusado por código CVV (código de segurança)
                                        inválido. <br/>
                                        CPF: 12345678909
                                    </p>
                                    <br/>
                                    <p className="m-0">
                                        Nome do titular: EXPI <br/>
                                        Descrição: Simula um pagamento recusado por data de vencimento do cartão
                                        inválido. <br/>
                                        CPF: 12345678909
                                    </p>
                                    <br/>
                                    <p className="m-0">
                                        Nome do titular: FORM <br/>
                                        Descrição: Simula um pagamento recusado por erro no formulário. <br/>
                                        CPF: 12345678909
                                    </p>
                                </AccordionTab>
                            </Accordion>

                            <CardPayment locale={"pt-BR"}
                                         initialization={{amount: entidade.plano?.valor!}}
                                         onSubmit={async (param: ICardPaymentFormData<ICardPaymentBrickPayer>) => {
                                             await Ajax.of()
                                                 .setTokenKeycloak(token!)
                                                 .postRegistroCustom(`${rest.server}${rest.mercadoPago}/${rest.mercadoPagoPagamentoCartaoCredito}`, param, async (response: PagamentoResponse) => {
                                                 info(response.mensagem);
                                                 setPagamentoVisible(false);

                                                 pagamentoDTO.status = response.status;
                                                 pagamentoDTO.idTransacaoMercadoPago = response.idTransacaoMercadoPago;

                                                 await salvarRestaurante(pagamentoDTO);
                                                 navigate("/restaurante");
                                             }, (err: Error) => {
                                                 const response: PagamentoResponse = JSON.parse(err.message);
                                                 error(response.mensagem);
                                                 setPagamentoVisible(false);
                                                 if (endLoadingSalvarFunction) endLoadingSalvarFunction();
                                             });
                                         }}
                            />
                        </p>
                    </>
                )}

                {pagamentoDTO.formaPagamento === TipoPagamento.PIX && (
                    <>
                        <br/>
                        <div className={styles.formatacaoTextoPix}>
                            {pagamentoDTO.idTransacaoMercadoPago === undefined && (
                                <>
                                    <div>
                                        * Clique em '{`Pagar ${DinheiroUtils.formatToDinheiro(entidade.plano?.valor!)}`}' para gerar o QR Code do PIX.
                                        <br/>
                                        * O pagamento será validado em até 10 minutos.
                                        <br/>
                                        * O banner ficará pendente até o pagamento ser autorizado.
                                    </div>
                                </>
                            )}
                        </div>

                        <div>
                            <div style={{position: "relative", float: "left", paddingRight: "10px"}}>
                                <br/>
                                <Botao id={"pagarPixButton"}
                                       loading={loadingPix}
                                       icon={PrimeIcons.MONEY_BILL}
                                       label={`Pagar ${entidade.plano?.valor!.toLocaleString("pt-BR", {
                                           style: 'currency',
                                           currency: 'BRL'
                                       })}`}
                                       onClickHandler={efetuarPagamentoPix}/>
                            </div>
                        </div>
                    </>
                )}
            </Dialog>

            <ConfirmDialog group={"copiarHorariosConfirm"} visible={copiarHorariosConfirm}
                           message={
                            <>
                                <div>Tem certeza que deseja copiar os horários do dia selecionado?<br />
                                    <h3>Atenção, os horários informados na data selecionada
                                        <br />vão substituir todos os horários no dia.</h3>
                                </div>
                            </>}
                           header="Atenção" icon="pi pi-exclamation-triangle"
                           accept={copiarHorariosDoDiaSelecionado}
                           acceptLabel={"Sim"} rejectLabel={"Não"} defaultFocus={"reject"}
                           acceptClassName={"p-button-danger"}
                           onHide={() => setCopiarHorariosConfirm(false)} />

            <ConfirmDialog group={"adicionarHorarioConfirm"} visible={adicionarHorarioConfirm}
                           message={
                               <>
                                   <div>Tem certeza que deseja adicionar esse horário no dia selecionado?<br />
                                       <h3>Atenção, o horário informado na data selecionada
                                           <br />vai substituir todos os horários no dia.</h3>
                                   </div>
                               </>}
                           header="Atenção" icon="pi pi-exclamation-triangle"
                           accept={adicionarRestauranteDiaDiferenciais}
                           acceptLabel={"Sim"} rejectLabel={"Não"} defaultFocus={"reject"}
                           acceptClassName={"p-button-danger"}
                           onHide={() => setAdicionarHorarioConfirm(false)} />

            <EditView title={"Restaurante"}
                      id={`${rest.restaurante}`}
                      entidade={entidade}
                      onSalvarHandler={iniciarPagamento}
                      sairAoSalvar={false}
                      onValidationHandler={validar}
                      entidadeUseStateFunction={editEntidade}>

                {JSON.parse(rest.periodoBeta!) === false && (
                    <>
                        <Fieldset legend={"Plano do restaurante"}>
                            <div>Selecione o plano. Escolha as opções pagas para obter todos os benefícios.</div>

                            <br />
                            <br />

                            <Combo values={planos} id={"plano"} filter={true}
                                   optionLabel={"descricao"}
                                   itemTemplate={planosItemTemplate}
                                   valueTemplate={planosValueTemplate}
                                   placeHolder={"Selecione um plano para o restaurante"}
                                   onChangeHandler={planoOnChangeHandler}
                                   label={"* Plano"} value={entidade.plano} />
                        </Fieldset>

                        <br />
                        <br />
                    </>
                )}

                <Accordion activeIndex={0}>
                    <AccordionTab header="Informações gerais">

                        <RoleBasedAccess roles={TipoUsuarioKeycloak.ADMIN}>
                            <Combo values={usuarios} id={"usuario"} filter={true}
                                   optionLabel={"nome"} optionValue={"id"}
                                   itemTemplate={usuariosItemTemplate}
                                   valueTemplate={usuariosValueTemplate}
                                   placeHolder={"Selecione um usuário para o restaurante"}
                                   onChangeHandler={usuarioOnChangeHandler}
                                   label={"* Usuário"} value={entidade.usuarioUuid} />

                            <Combo values={restauranteStatus} id={"status"} filter={true}
                                   placeHolder={"Selecione um status para o restaurante"}
                                   onChangeHandler={statusOnChangeHandler}
                                   label={"Status"} value={entidade.status} />

                            <Divider />
                        </RoleBasedAccess>

                        <Texto id={"nomeEstabelecimento"} value={entidade.nomeEstabelecimento}
                               label={"* Nome do estabelecimento"} size={"100%"} maxLength={255}
                               tooltip={"Informe o nome do estabelecimento"} tooltipPosition={TooltipPosition.TOP}
                               onChangeHandler={entidadeOnChangeHandler}/>

                        <Texto id={"razaoSocial"} value={entidade.razaoSocial}
                               label={"* Razão social"} size={"100%"} maxLength={255}
                               tooltip={"Informe a razão social"} tooltipPosition={TooltipPosition.TOP}
                               onChangeHandler={entidadeOnChangeHandler}/>

                        <CpfCnpj id={"cpfCnpj"} value={entidade.cpfCnpj} unmask={true}
                                 label={"* CPF/CNPJ"} size={"100%"} maxLength={14}
                                 tooltip={"Informe o CPF ou CNPJ"} tooltipPosition={TooltipPosition.TOP}
                                 onChangeHandler={entidadeOnChangeHandler}/>

                        <GoogleMapsAutoComplete id={"enderecoCompleto"}
                                                value={entidade.enderecoCompleto}
                                                label={"* Endereço Completo"}
                                                size={"100%"} maxLength={255}
                                                tooltip={"Informe o endereço completo"}
                                                tooltipPosition={TooltipPosition.TOP}
                                                onKeyDownHandler={redefinirLatitudeLongitute}
                                                onChangeHandler={enderecoCompletoOnChangeHandler}
                                                afterSelectAddress={definirLatitudeLongitudeEndereco}
                                                />

                        <Telefone id={"telefone"} label={"Telefone"} value={entidade.telefone}
                                  size={"100%"}
                                  tooltip={"Informe um telefone/celular"} tooltipPosition={TooltipPosition.TOP}
                                  onChangeHandler={entidadeOnChangeHandler}/>

                        <TelefoneBR id={"whatsapp"} label={"WhatsApp"} value={entidade.whatsapp}
                                        size={"100%"}
                                        tooltip={"Informe um número de WhatsApp"} tooltipPosition={TooltipPosition.TOP}
                                        onBlurHandler={whatsAppValidateOnBlurHandler}
                                        onChangeHandler={whatsAppOnChangeHandler} />

                        <Divider/>

                        <div className="formgrid grid">
                            <div className="field col">
                                <TextoGrupo id={"instagram"} value={entidade.instagram}
                                            labelGrupo={"https://instagram.com/"}
                                            label={"Instagram"} size={"100%"} maxLength={200}
                                            fullSize={true}
                                            placeholder={"Ex: meurestaurante"}
                                            tooltip={"Informe o ID do seu Instagram"}
                                            tooltipPosition={TooltipPosition.TOP}
                                            onChangeHandler={entidadeOnChangeHandler}/>
                            </div>
                            <div className="field col">
                                <TextoGrupo id={"facebook"} value={entidade.facebook}
                                            labelGrupo={"https://facebook.com/"}
                                            fullSize={true}
                                            placeholder={"Ex: meurestaurante"}
                                            label={"Facebook"} size={"100%"} maxLength={200}
                                            tooltip={"Informe o ID do seu Facebook"}
                                            tooltipPosition={TooltipPosition.TOP}
                                            onChangeHandler={entidadeOnChangeHandler}/>
                            </div>
                            <div className="field col">
                                <Texto id={"site"} value={entidade.site}
                                            fullSize={true}
                                            placeholder={"Ex: meurestaurante.com.br"}
                                            label={"Site do restaurante"} size={"100%"} maxLength={200}
                                            tooltip={"Informe o site do seu restaurante"}
                                            tooltipPosition={TooltipPosition.TOP}
                                            onChangeHandler={entidadeOnChangeHandler}/>
                            </div>
                        </div>

                    </AccordionTab>


                    <AccordionTab header="Categorias">
                        <ItemEditView id={"restauranteTipoRestaurante"}
                                      title={"Categorias"}
                                      sortFieldPadrao={"tipoRestaurante.nomeAtividade"}
                                      adicionarFunction={adicionarRestauranteTipos}
                                      editarItemFunction={editarRestauranteTipos}
                                      removerItemFunction={removerRestauranteTipos}
                                      itens={entidade.tiposRestaurantes}
                                      colunas={[
                                          ItemEditViewColuna.of("tipoRestaurante.nomeAtividade", "Categoria"),
                                          ItemEditViewColuna.of("status", "Ativo", statusRestauranteTipoTemplate)
                                      ]}>
                            <Combo id={"tipoRestaurante"} label={"* Categoria"}
                                   optionLabel={"nomeAtividade"}
                                   placeHolder={"Selecione a categoria"}
                                   onChangeHandler={restauranteTipoOnChangeHandler}
                                   value={restauranteTipo.tipoRestaurante} values={tiposRestaurantes}/>

                            <Switch checked={statusRestauranteTipo} id={"status"} label={statusRestauranteTipo ? "Ativo" : "Inativo"}
                                    onChangeHandler={switchOnChangeHandler}/>
                        </ItemEditView>
                    </AccordionTab>

                    <AccordionTab header="Diferenciais">
                        <ItemEditView id={"restauranteDiferencial"}
                                      title={"Diferenciais"} key={"diferenciaisKey"}
                                      adicionarFunction={adicionarRestauranteDiferenciais}
                                      editarItemFunction={editarRestauranteDiferenciais}
                                      removerItemFunction={removerRestauranteDiferenciais}
                                      itens={entidade.diferenciais}
                                      colunas={[
                                          ItemEditViewColuna.of("diferencial.nomeDiferencial", "Diferencial"),
                                          ItemEditViewColuna.of("status", "Ativo", statusRestauranteDiferencialTemplate)
                                      ]}>
                            <Combo id={"diferencial"} label={"* Diferencial"}
                                   optionLabel={"nomeDiferencial"}
                                   placeHolder={"Selecione um diferencial"}
                                   onChangeHandler={restauranteDiferencialOnChangeHandler}
                                   value={restauranteDiferencial.diferencial} values={diferenciais}/>

                            <Texto id={"observacao"} label={"Detalhes"} value={restauranteDiferencial.observacao}
                                   maxLength={50}
                                   placeholder={"Ex: Precisa reservar com antecedência"}
                                   onChangeHandler={restauranteDiferencialOnChangeHandler}/>

                            <Switch checked={statusRestauranteDiferencial} id={"status"} label={statusRestauranteDiferencial ? "Ativo" : "Inativo"}
                                    onChangeHandler={switchDiferencialOnChangeHandler}/>
                        </ItemEditView>
                    </AccordionTab>

                    <AccordionTab header="Horário de funcionamento">
                        <Card title={"Dias / Horários de funcionamento"}>
                            <div className={styles.textoExplicativo}>Adicione os horários <b>somente em dias de funcionamento</b>, com seus respectivos intervalos, conforme exemplo:
                                <br /><b>Abre:</b> 08:00  <b>Fecha:</b> 12:00
                                <br /><b>Abre:</b> 14:00  <b>Fecha:</b> 18:00
                            </div>

                            <br />

                            <div className={styles.textoExplicativo}>
                                Se o horário for por exemplo: <b>"Sábado abre às 19h e fecha às 02h"</b> ficaria assim:
                                <br /><b>Sábado = Abre:</b> 19:00 <b>Fecha:</b> 23:59
                                <br /><b>Domingo = Abre:</b> 00:00 <b>Fecha:</b> 02:00
                            </div>

                            <br />

                            {entidade.horariosFuncionamento ?
                                (entidade.horariosFuncionamento.map((horarioFuncionamento, horarioFuncionamentoIndex) => (
                                    <>
                                        <div key={horarioFuncionamentoIndex} className={styles.componentePaiHorarioFuncionamento}>
                                            <div className={styles.componentePaiHorarioFuncionamento}>
                                                {horarioFuncionamento.diaSemana}
                                            </div>

                                            {horarioFuncionamento.periodos !== undefined && horarioFuncionamento.periodos.length > 0 &&
                                                (horarioFuncionamento.periodos.map((periodo, periodoIndex) => (
                                                    <>
                                                        <div>
                                                            <InputMask id={"horaInicio"} mask={"99:99"} placeholder={"Abre"}
                                                                       width={"100px"}
                                                                       value={periodo.horaInicio}
                                                                       onChange={(e: any) => periodoFuncionamentoChangeHandler(e, horarioFuncionamentoIndex, periodoIndex)}
                                                                       onBlur={() => validarHorarioFuncionamentoOnBlurHandler(periodo.horaInicio, periodo.horaFim)}
                                                                       className={styles.componentesHorarioFuncionamento} />
                                                            <InputMask id={"horaFim"} mask={"99:99"} placeholder={"Fecha"}
                                                                       width={"100px"}
                                                                       value={periodo.horaFim}
                                                                       onChange={(e: any) => periodoFuncionamentoChangeHandler(e, horarioFuncionamentoIndex, periodoIndex)}
                                                                       onBlur={() => validarHorarioFuncionamentoOnBlurHandler(periodo.horaInicio, periodo.horaFim)}
                                                                       className={styles.componentesHorarioFuncionamento} />

                                                            <div className={styles.switchDelivery}>
                                                                <InputSwitch checked={periodo.delivery ?? false} id={"delivery"}
                                                                    onChange={(e: any) => periodoFuncionamentoChangeHandler(e, horarioFuncionamentoIndex, periodoIndex)}
                                                                />
                                                                <label
                                                                    htmlFor={"delivery"}>Somente delivery?</label>
                                                            </div>

                                                            <Button icon={PrimeIcons.TRASH} label={"Limpar"}
                                                                    severity={"danger"}
                                                                    className={styles.componentesHorarioFuncionamento}
                                                                    onClick={() => removerPeriodoFuncionamentoHandler(horarioFuncionamento, horarioFuncionamentoIndex, periodoIndex)} />
                                                        </div>
                                                    </>
                                            )))}

                                            <div>
                                                <Button icon={PrimeIcons.PLUS} label={"Adicionar novo horário"}
                                                        onClick={() => adicionarPeriodoFuncionamentoHandler(horarioFuncionamento, horarioFuncionamentoIndex)} />
                                            </div>
                                        </div>
                                    </>
                                ))) : (<></>)
                            }
                        </Card>
                    </AccordionTab>

                    <AccordionTab header="Horários em datas especiais">
                        <div ref={horariosEspeciaisScrollRef}></div>
                        <ItemEditView id={"restauranteHorarioFuncionamentoDiferencial"}
                                      title={"Horários em datas especiais"}
                                      adicionarFunction={() => setAdicionarHorarioConfirm(true)}
                                      editarItemFunction={editarRestauranteDiaDiferenciais}
                                      removerItemFunction={removerRestauranteDiaDiferenciais}
                                      itens={entidade.horariosFuncionamentoDiferencial}
                                      colunas={[
                                          ItemEditViewColuna.of("data", "Data", dataRestauranteDiaDiferencialTemplate),
                                          ItemEditViewColuna.of("status", "Aberto", statusRestauranteDiaDiferencialTemplate),
                                          ItemEditViewColuna.of("horaInicio", "Abre"),
                                          ItemEditViewColuna.of("horaFim", "Fecha"),
                                          ItemEditViewColuna.of("delivery", "Somente delivery?", deliveryRestauranteDiaDiferencialTemplate),
                                      ]}>

                            <div className={styles.textoExplicativo}>Adicione os horários somente em datas de
                                <b> funcionamento diferenciados para sobrepor o horário normal</b>,
                                confome exemplos: <br/><b>Data:</b> 25/12 <b>Fechado</b>
                                <br/><b>Data:</b> 01/01 <b>Abre:</b> 18:00 <b>Fecha:</b> 22:00
                            </div>

                            <br/>
                            <br/>

                            <div className="formgrid grid">
                                <div className="field col-12">
                                    <Calendario id={"data"} label={"* Data"} value={restauranteDiaDiferencial.data}
                                                fullSize={false} minDate={new Date()}
                                                onChangeHandler={restauranteDiaDiferencialOnChangeHandler}/>
                                </div>

                                <div className="col-12">
                                    <Switch checked={statusRestauranteDiaDiferencial} id={"status"}
                                            label={statusRestauranteDiaDiferencial ? "Fechado" : "Aberto"}
                                            onChangeHandler={switchDiaDiferencialOnChangeHandler}/>
                                </div>

                                <div className="field col-12"
                                     style={{display: `${statusRestauranteDiaDiferencial ? "none" : "block"}`}}>
                                    <Botao id={"copiar"} label={"Copiar os horários do dia selecionado"}
                                           icon={PrimeIcons.COPY}
                                           hint={"Será feito uma cópia do horário de atendimento normal do dia escolhido, para que seja alterado."}
                                           style={{width: "390px", marginBottom: "20px"}}
                                           onClickHandler={() => setCopiarHorariosConfirm(true)}/>
                                </div>

                                <div className="field col-12"
                                     style={{display: `${statusRestauranteDiaDiferencial ? "none" : "block"}`}}>
                                    <Divider/>
                                    <h3>Ou preencher os campos abaixo:</h3>
                                    <br/>
                                </div>

                                <div className="field col-12"
                                     style={{display: `${statusRestauranteDiaDiferencial ? "none" : "block"}`}}>
                                    <TextoMascara id={"horaInicio"} label={"* Abre"}
                                                  value={restauranteDiaDiferencial.horaInicio}
                                                  mask={"99:99"} fullSize={false}
                                                  disabled={statusRestauranteDiaDiferencial}
                                                  onChangeHandler={restauranteDiaDiferencialOnChangeHandler}/>
                                </div>

                                <div className="field col-12"
                                     style={{display: `${statusRestauranteDiaDiferencial ? "none" : "block"}`}}>
                                    <TextoMascara id={"horaFim"} label={"* Fecha"}
                                                  value={restauranteDiaDiferencial.horaFim}
                                                  mask={"99:99"} fullSize={false}
                                                  disabled={statusRestauranteDiaDiferencial}
                                                  onChangeHandler={restauranteDiaDiferencialOnChangeHandler}/>
                                </div>

                                <div className="field col-12"
                                     style={{display: `${statusRestauranteDiaDiferencial ? "none" : "block"}`}}>
                                    <Switch id={"delivery"} label={"Somente delivery?"}
                                            onChangeHandler={restauranteDiaDiferencialOnChangeHandler}
                                            checked={restauranteDiaDiferencial.delivery ?? false} />
                                </div>
                            </div>
                        </ItemEditView>

                    </AccordionTab>
                </Accordion>
            </EditView>
            <div ref={bottomCopiaHorariosRef}></div>
        </>
    );
}

export default RestauranteEdit;